import { mode } from "@chakra-ui/theme-tools";

export const buttonStyles = {
  components: {
    Button: {
      variants: {
        navy: {
          bg: '#2A4365',
          color: 'white',
          _hover: { bg: '#2A4365' },
          _active: { bg: '#2A4365' },
          _disabled: { bg: '#2A4365', opacity: 0.4, color: 'white' },
        },
        green: {
          bg: '#276749',
          color: 'white',
          _hover: { bg: '#276749' },
          _active: { bg: '#276749' },
          _disabled: { bg: '#276749', opacity: 0.4, color: 'white' },
        },
        
        "no-effects": {
          _hover: "none",
          _active: "none",
          _focus: "none",
        },
        danger: () => ({
          color: "white",
          bg: "red.500",
          fontSize: "10px",
          _hover: "red.400",
          _focus: "red.400",
          _active: "red.400",
        }),
        outlined: (props) => ({
          color: mode("blue.400", "white")(props),
          bg: "transparent",
          fontSize: "10px",
          border: "1px solid",
          borderColor: mode("blue.400", "white")(props),
          _hover: { bg: mode("blue.50", "transparent")(props) },
          _focus: { bg: mode("blue.50", "transparent")(props) },
          _active: { bg: mode("blue.50", "transparent")(props) },
        }),
        dark: (props) => ({
          color: "white",
          bg: mode("black", "blue.500")(props),
          fontSize: "10px",
          _hover: { bg: mode("black", "blue.500")(props) },
          _focus: { bg: mode("black", "blue.600")(props) },
          _active: { bg: mode("black", "blue.400")(props) },
        }),
        light: (props) => ({
          color: mode("black", "black")(props),
          bg: mode("gray.100", "white")(props),
          fontSize: "10px",
          _hover: { bg: mode("gray.50", "white")(props) },
          _focus: { bg: mode("gray.50", "white")(props) },
          _active: { bg: mode("gray.50", "white")(props) },
        }),
        display: {
          fontSize: "sm",
          bg: "black",
          color: "white",
          _hover: { bg: "gray.800" },
          _focus: { bg: "gray.800" },
          _active: { bg: "gray.800" },
          borderRadius: "5px",
        },
      },
      baseStyle: {
        fontWeight: "bold",
        borderRadius: "8px",
        fontSize: "10px",
      },
    },
  },
};